{
  "myData.delete.section.heading": "Tilin poistaminen",
  "myData.delete.section.description": "Voit poistaa tilisi ja siihen liittyvät henkilötiedot pysyvästi. Toimintoa ei voi perua.",
  "myData.delete.trigger": "Poista tili",
  "myData.delete.title": "Poista tili",
  "myData.delete.irreversible": "Tilin poistaminen on lopullista, eikä sitä voi perua. Tietosi poistetaan heti, eikä poistolle ole peruutusaikaa.",
  "myData.delete.retainedNote": "Lakisääteisesti säilytettävät tapahtumatiedot säilytetään ilman henkilötietojasi.",
  "myData.delete.confirm": "Poista tili pysyvästi",
  "myData.delete.cancel": "Peruuta",
  "myData.delete.pending": "Poistetaan…",
  "myData.delete.done": "Tilisi on poistettu.",
  "myData.delete.doneClose": "Sulje",
  "myData.delete.unavailable": "Tilin poistaminen ei ole vielä käytettävissä.",
  "myData.delete.error": "Tilin poistaminen epäonnistui. Yritä uudelleen."
}
